<template>
  <DetailComposer
    :resume="
      locale === 'fr'
        ? composer?.resume
        : composer?.resumeEn ?? composer?.resume
    "
    :composer="composer"
    :active-outline-id="'analyses'"
  >
    <template #typeIcon>
      <div
        class="m-14 hidden h-40 w-40 shrink-0 items-center justify-center bg-white sm:flex lg:h-60 lg:w-60"
        v-if="composer?.photo?.getUrl"
      >
        <div class="relative">
          <img
            :src="composer?.photo?.getUrl"
            :alt="
              'Analyses of ' + composer?.firstName + ' ' + composer?.lastName
            "
            class="h-full w-full object-cover sm:p-0"
          />
          <span
            v-if="composer?.copyrights"
            class="absolute right-1 bottom-0 text-white"
            >© {{ composer?.copyrights }}</span
          >
        </div>
      </div>
    </template>
    <div class="divide-y divide-shade-200">
      <ListRow
        v-for="item in analyses"
        :key="item.id"
        class="cursor-pointer"
        @click="goToResource(item)"
      >
        <template #leftIcon>
          <img :src="item.image?.getUrl" :alt="item.title" class="h-24 w-24" />
        </template>
        <h4
          v-html="item.title"
          class="text-mobile-lg font-semibold transition-colors duration-200 ease-in-out first-letter:uppercase group-hover:text-primary-400 md:text-lg"
        />
        <div
          v-html="item.text.slice(0, 200)"
          class="font-serif text-base text-shade-500 first-letter:uppercase"
        />
      </ListRow>
    </div>
  </DetailComposer>
</template>
<script lang="ts" setup>
import { getPersonBySlug } from '~/queries/composer'
const { slug } = useResourceSlug()
const { data, pending, error } = await useAsyncData<Analysis[], Error>(
  `/composer/${slug}`,
  async (): Promise<Analysis[]> =>
    await execQuery(() => getPersonBySlug('analyses'), { slug })
)

const { locale } = useI18n()

const composer = computed<Composer>(() => {
  if (pending.value || error.value) return null
  return data.value.data.personBySlug
})

const analyses = computed<Composer>(() => {
  if (pending.value || error.value) return null
  return composer.value?.analyses
})

const title = computed(() => {
  return `Analyses - ${composer.value?.firstName} ${composer.value?.lastName}`
})

const description = computed(() => {
  return `La liste des analyses du compositeur ${composer.value?.firstName} ${composer.value?.lastName}`
})

useHead({
  title,
  meta: [
    {
      name: 'description',
      content: description,
    },
  ],
})

useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description,
  ogImage: composer.value?.photo?.getUrl,
  twitterCard: 'summary',
})
// Navigation
const { goToResource } = useGoToResource()
</script>
